export default __webpack_public_path__ + "media/images/features/local_delivery/episode4/LP_04-a3726c7f2b3c2a590ff0f1dd7b6d89cb.jpg";